module.exports = __webpack_public_path__ + "static/media/serbia.5531b4e7.jpg";